import { PublicClientApplication } from "@azure/msal-browser";

import { msalConfig } from "config/auth-config";

// Export msalInstance for use in mutator and other config files
// This file should not import CSS or assets to avoid issues with orval/esbuild
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * MSAL v3+ requires async initialization. For redirect flows you must also process the redirect response
 * via handleRedirectPromise before starting any new interactive requests.
 */
export async function initializeMsal(): Promise<void> {
  await msalInstance.initialize();

  // Must be awaited for redirect flows to avoid interaction_in_progress.
  // https://learn.microsoft.com/en-us/entra/msal/javascript/browser/errors#interaction_in_progress
  const redirectResult = await msalInstance.handleRedirectPromise().catch(() => null);
  if (redirectResult?.account) {
    msalInstance.setActiveAccount(redirectResult.account);
  }

  if (!msalInstance.getActiveAccount()) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
}
